var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Card } from '../Card';
import { TabsHeader } from './TabsHeader';
const PanelContentWrapper = styled.div `
  font-family: ${({ theme: { fonts } }) => fonts.regular};
  [tabindex='-1'] {
    outline: none;
  }
`;
export const TabsBase = (_a) => {
    var { disableContainer = false, selectedTab, onSelectedTabChange, tabs, activeTab, onActiveTabChange, panelContentRef } = _a, conditionalProps = __rest(_a, ["disableContainer", "selectedTab", "onSelectedTabChange", "tabs", "activeTab", "onActiveTabChange", "panelContentRef"]);
    // componentContent is the entire Tabs component content that
    // will or will not appear inside a Card. Includes the header
    // and the contents of the selected tab
    const componentContent = (React.createElement(React.Fragment, null,
        React.createElement(TabsHeader, Object.assign({ activeTab: activeTab, onActiveTabChange: onActiveTabChange, selectedTab: selectedTab, onSelectedTabChange: onSelectedTabChange, tabs: tabs.map(tab => {
                var _a;
                return ({
                    label: tab.label,
                    ariaLabel: (_a = tab.ariaLabel) !== null && _a !== void 0 ? _a : tab.label,
                    allytmln: tab.allytmln,
                });
            }), disableContainer: disableContainer }, conditionalProps)),
        React.createElement(PanelContentWrapper, { ref: (r) => {
                panelContentRef.current = r;
            } }, tabs[selectedTab].panel)));
    return !disableContainer ? (React.createElement(Card, { closeButton: false }, componentContent)) : (componentContent);
};
//# sourceMappingURL=TabsBase.js.map